<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new"
            :back-button="true"
            :bigTotal="pendingDenunciation"
            :loading="loading" :total="pendingDenunciation"
            :label="'Dénonciation en attente'">
      <a @click="exportXls('denunciations-export', query, true)" class="dropdown-item" slot="dropdown-content"
         v-if="isAdmin || isSectorManager">
        <span class="icon"><i class="fas fa-file-excel"></i></span>
        <span>Exporter dénonciations</span>
      </a>
      <a @click="loadItems()"  class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-sync"></i></span>
        <span>Actualiser</span>
      </a>
    </sticky>
    <spinner-round :isLoading="loading" v-if="loading"></spinner-round>
    <div class="columns page-content collapseColumn collapseColumn--left collapseColumn--alignStart" id="columns-collapse"
         :class="opened ? 'is-active-collapse' : 'is-inactive-collapse'">
      <div class="column is-4 is-3-widescreen is-3-fullhd">
        <list-filter @resetFilters="resetFilters"
                     @changeFilters="changeFilters"
                     :total="total"
                     :bigTotal="bigTotal"
                     :loading="loading"
                     :hasFilter="hasFilter"
                     @opened="opened = !opened">
          <div v-if="isAdmin || isSectorManager" class="columns">
            <div class="column is-paddingless-bottom is-padding-top-small">
              <div class="control">
                <multiselect @select="updateCompanyFilter" @remove="updateCompanyFilter(null)"
                            class="multiselect--option-ico is-single_choice"
                            v-model="filters.company" track-by="pk"
                            :options="companies" :searchable="true"
                            :custom-label="companyName" :show-labels="false" :placeholder="''"
                            @search-change="getCompanies">
                  <span slot="placeholder" class="multiselect__placeholder">Société</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-paddingless-bottom is-padding-top-xsmall">
              <div class="control">
                <multiselect @select="updateContactFilter" @remove="updateContactFilter(null)"
                             v-model="filters.buyer" label="name" track-by="pk"
                             class="multiselect--option-ico"
                             :custom-label="sellerName"
                             :options="contacts" :searchable="true"  :show-labels="false"
                             :placeholder="''" @search-change="getContacts">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="contacts.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucun contact trouvé.</span>
                  <span slot="placeholder" class="multiselect__placeholder">Contact</span>
                  <span slot="singleLabel" class="multiselect__placeholder">Contact</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns" v-if="isDistributeurMode && !isExternal">
            <div class="column is-paddingless-bottom is-padding-top-xsmall">
              <div class="control">
                <multiselect @select="updatePromoteurFilter" @remove="updatePromoteurFilter(null)"
                             v-model="filters.promoteur" label="name" track-by="pk"
                             class="multiselect--option-ico"
                             :options="promoteurs" :searchable="true"  :show-labels="false"
                             :placeholder="''" @search-change="getPromoteurs">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="promoteurs.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucun promoteur trouvé.</span>
                  <span slot="placeholder" class="multiselect__placeholder">Promoteur</span>
                  <span slot="singleLabel" class="multiselect__placeholder">Promoteur</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-padding-top-xsmall is-paddingless-bottom">
              <div class="control">
                <multiselect @select="updateProgramFilter" @remove="updateProgramFilter(null)"
                             v-model="filters.program"
                             label="name"
                             track-by="pk"
                             class="multiselect--option-ico"
                             :options="programs" :searchable="true"  :show-labels="false"
                             @search-change="getPrograms">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="programs.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucun programme trouvé.</span>
                  <span slot="placeholder" class="multiselect__placeholder">Programme</span>
                  <span slot="singleLabel" class="multiselect__placeholder">Programme</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-paddingless-bottom is-padding-top-xsmall">
              <div class="control">
                <multiselect @select="updateLotFilter" @remove="updateLotFilter(null)"
                             v-model="filters.lot" label="ref" track-by="pk"
                             class="multiselect--option-ico"
                             :options="lots" :searchable="true"  :show-labels="false"
                             :placeholder="''" @search-change="getLots">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="lots.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucun lot trouvé.</span>
                  <span slot="placeholder" class="multiselect__placeholder">Lot</span>
                  <span slot="singleLabel" class="multiselect__placeholder">Lot</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns" v-if="isAdmin || isSectorManager || isManager">
            <div class="column is-padding-top-xsmall is-paddingless-bottom">
              <div class="control">
                <multiselect @select="updateSellerFilter" @remove="updateSellerFilter(null)"
                             v-model="filters.seller" label="seller" track-by="pk"
                             class="multiselect--option-ico"
                             :custom-label="sellerName" :placeholder="''"
                             :options="users" :searchable="true"  :show-labels="false"
                             @search-change="getUsers">
                  <span slot="placeholder" class="multiselect__placeholder">Vendeur</span>
                  <span slot="singleLabel" class="multiselect__placeholder">Vendeur</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns is-padding-left is-padding-right is-padding-bottom">
            <div class="column is-paddingless-left is-paddingless-right is-paddingless-bottom is-padding-top-xsmall">
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-square is-static is-border is-min-width-0">
                    <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded has-icons-right">
                  <flat-pickr :config="configDate" v-model="denuncePeriod"
                              class="input is-radiusless" name="date"
                              placeholder="Période"
                              @on-change="updateDenuncePeriodFilter">
                  </flat-pickr>
                </div>
                <div class="control">
                  <a class="button is-square is-grey is-inverted is-border is-min-width-0"
                     @click="denuncePeriod = null">
                    <span class="icon"><i class="fas fa-times"></i></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </list-filter>
      </div>
      <div class="column is-8 is-9-widescreen is-9-fullhd">
        <div class="is-border">
          <div class="columns is-gapless row-width-actions-bar is-border-bottom">
            <transition enter-active-class="animated fadeIn faster" leave-active-class="animated fadeOut faster" mode="out-in">
              <div class="column is-narrow has-bg-primary columns is-vcentered is-gapless" v-if="hasFilter && !loading && total !== bigTotal">
                <div class="column is-padding-left is-padding-right has-text-white">Résultat : {{total || 0}} dénonciation(s)</div>
              </div>
            </transition>
            <div class="column"></div>
            <div class="column is-narrow">
              <button class="page-header-btn is-square is-static is-ghost">
                <span class="icon"><i class="fas"></i></span>
              </button>
            </div>
          </div>
          <div class="is-padding-top is-padding-left is-padding-right" v-if="hasFilter">
            <label for="" class="is-size-6 label is-padding-bottom-small">Vos critères de recherche :</label>
            <div class="tags">
              <span class="tag is-primary is-rounded" v-if="filters.buyer">
                {{sellerName(filters.buyer)}} <a @click="updateContactFilter(null)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.company">
                {{filters.company.name}} <a @click="updateCompanyFilter(null)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.promoteur">
                {{filters.promoteur.name}} <a @click="updatePromoteurFilter(null)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.program">
                {{filters.program.name}} <a @click="updateProgramFilter(null)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.lot">
                {{filters.lot.ref}} <a @click="updateLotFilter(null)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.seller">
                {{sellerName(filters.seller)}} <a @click="updateSellerFilter(null)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="denuncePeriod">
                {{denuncePeriod}} <a @click="denuncePeriod = null" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-annonce is-rounded has-cursor-pointer" @click="resetFilters">
                Réinitialiser les filtres <span class="icon is-white is-margin-left-xsmall"><i class="fas fa-undo"></i></span>
              </span>
            </div>
          </div>
          <div class="column is-narrow is-padding-top-small is-padding-bottom-small">
            <label class="checkbox checkRadioIsHide is-padding-right-xsmall" :for="s.value"
                  v-for="s in denunciationStatusList" :key="s.value">
              <input type="checkbox" :id="s.value" v-model="filters.status" @click="inputChange" :value="s.value">
              <span class="tag" :class="tagColors(s.value)">
                <span>{{s.label}}</span>
                <span class="icon">
                  <i class="far" :class="filters.status && filters.status.length && filters.status.includes(s.value) ? 'fa-check-square' : 'fa-square'"></i>
                </span>
              </span>
            </label>
          </div>
          <div>
            <table-h-scroll :has-sticky="true" :sticky-styles="stickyStyles"
                            :sticky-datas="stickyDatas" :reload-controls="loading && items.length">
              <table v-show="!loading && items.length"
                     class="table is-fullwidth is-marginless-bottom is-last-fixed-small has-actionsontd">
                <thead>
                <tr class="is-size-6">
                  <th class="is-paddingless has-text-centered actions" style="z-index:2;">
                    <div class="dropdown is-hoverable is-left">
                      <div class="dropdown-trigger">
                        <button class="button is-circle is-small" aria-haspopup="true" aria-controls="dropdown-menu">
                          <i class="fal fa-cog"></i>
                        </button>
                      </div>
                      <columns-toggles :entries="columnsList" :source="columns" @update="updateColumns"></columns-toggles>
                    </div>
                  </th>
                  <th>
                    <sortable @sort="sort('lot_ref', $event)" :sort="sortBy.lot_ref" label="Lot"></sortable>
                  </th>
                  <th v-if="showColumn('program_name')">
                    <sortable @sort="sort('program_name', $event)" :sort="sortBy.program_name"
                              label="Programme"></sortable>
                  </th>
                  <th v-if="!isExternal && isDistributeurMode && showColumn('promoteur_name')">
                    <sortable @sort="sort('promoteur_name', $event)" :sort="sortBy.promoteur_name"
                              label="Promoteur"></sortable>
                  </th>
                  <th v-if="(isAdmin || isSectorManager) && showColumn('company_name')">
                    <sortable @sort="sort('company_name', $event)" :sort="sortBy.company_name" label="Société"></sortable>
                  </th>
                  <th v-if="(isAdmin || isSectorManager|| isManager) && showColumn('seller_name')">
                    <sortable @sort="sort('seller_name', $event)" :sort="sortBy.seller_name" label="Vendeur"></sortable>
                  </th>
                  <th v-if="showColumn('buyer_name')">
                    <sortable @sort="sort('buyer_name', $event)" :sort="sortBy.buyer_name" label="Contact"></sortable>
                  </th>
                  <th v-if="showColumn('created_on')">
                    <sortable @sort="sort('created_on', $event)" :sort="sortBy.created_on" label="Date de création"></sortable>
                  </th>
                  <th class="has-text-centered" width="70px" v-if="isSectorManager || isAdmin">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="denunciation in items" :key="denunciation.pk" is="denunciation-item"
                    :denunciation="denunciation"
                    :button-list="buttonList" class="is-size-6" :columns-selected="columns">
                </tr>
                <tr class="empty empty--row" v-for="n in items.length < 8 ? 8 - items.length : 0 " :key="n"><td class="is-borderless"></td></tr>
                </tbody>
              </table>
            </table-h-scroll>
            <div class="is-border-top" v-if="totalPage > 1 && nextPage && !loading">
              <a class="button is-light is-fullwidth has-text-grey" @click="loadMore(true)" v-if="!infiniteLoading">
                <span class="icon is-small is-size-6"><i class="fas fa-chevron-down"></i></span>
                <span class="is-size-6">Afficher la suite</span>
              </a>
              <div class="has-text-centered" v-else><img src="static/spinner2.svg" alt="spinner" style="height: 38px"></div>
            </div>
            <div v-show="!loading && !items.length">
              <div class="columns">
                <div class="column">
                  <h2 class="title is-3 has-text-weight-bold">Aucune Dénonciation</h2>
                  <a class="has-text-primary" @click="resetFilters" v-if="hasFilter"><span class="icon is-small"><i
                    class="fal fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { GenericList, Sort, Filter, ColumnConf, DefaultValues, DenunciationStatus, TableHeaderSticky } from '../../mixins'
  import { mapGetters, mapState } from 'vuex'
  import DenunciationItem from './DenunciationItem'
  import { exportXls } from '../../utils'
  import { isPlainObject, debounce, isNil } from 'lodash'
  import moment from 'moment'

  export default {
    name: 'DenunciationList',
    data () {
      return {
        users: [],
        columnsConfResource: 'denunciation',
        buttonList: [
          {
            action: (id) => {
              this.$api.denunciationService.patch(id, {status: 'approved'}).then(r => {
                this.updateDenunciation(id, r.data)
              })
            },
            icon: 'fa-check',
            text: 'Accepter',
            needProfile: ['admin'],
            display: (o) => {
              return this.canApprove(o.status)
            }
          },
          {
            action: (id) => {
              this.confirmDelete().then(r => {
                if (r.value) {
                  this.$api.denunciationService.patch(id, {status: 'refused'}).then(r => {
                    this.updateDenunciation(id, r.data)
                  })
                }
              })
            },
            icon: 'fa-times-octagon',
            text: 'Refuser',
            needProfile: ['admin'],
            display: (o) => {
              return this.canRefuse(o.status)
            }
          },
          {
            icon: ['fa-tasks'],
            text: 'Vérifier Doublons',
            needProfile: ['admin'],
            action: (id) => {
              this.$api.denunciationService.getDuplicate(id).then(r => {
                if (r.data.duplicates.length > 0) {
                  this.items.find(e => {
                    if (e.pk === id) {
                      e.duplicate_risk = r.data.duplicate_risk
                      return e
                    }
                  })
                  this.$notify({type: 'is-danger', text: 'Doublon trouvé'})
                } else {
                  this.$notify({type: 'is-success', text: 'Aucun doublon trouvé'})
                }
              })
            },
            display: (o) => {
              return this.canApprove(o.status) || this.canRefuse(o.status)
            }
          }
        ],
        companies: [],
        programs: [],
        lots: [],
        promoteurs: [],
        contacts: [],
        loadDocuments: this.loadItems,
        service: this.$api.denunciationService,
        dup: [],
        opened: true,
        pendingDenunciation: 0,
        exportXls,
        colors: ['is-optionne', 'is-warning', 'is-danger'],
        filters: {
          lot: undefined,
          pk: [],
          status: [],
          seller: undefined
        },
        initFilters: {
          lot: undefined,
          pk: [],
          status: [],
          seller: undefined
        },
        configDate: {
          altFormat: 'j/m/Y',
          altInput: true,
          dateFormat: 'd/m/Y',
          mode: 'range'
        },
        denuncePeriod: null,
        infiniteLoaderEnabled: true
      }
    },
    computed: {
      ...mapState({
        promoteursList: 'promoteurs'
      }),
      ...mapGetters(['isAdmin', 'isExternal', 'isManager', 'isSectorManager', 'isSeller', 'isDistributeurMode']),
      columnsShow () {
        const columns = {
          'program_name': {label: 'Programme', mobile: true}
        }
        if (!this.isExternal && this.isDistributeurMode) {
          columns.promoteur_name = {label: 'Promoteur', mobile: true}
        }
        if (this.isAdmin || this.isSectorManager || this.isManager) {
          columns.seller_name = {label: 'Vendeur', mobile: true}
        }
        if (this.isAdmin || this.isSectorManager) {
          columns.company_name = {label: 'Société', mobile: true}
        }
        columns.buyer_name = {label: 'Contact', mobile: true}
        columns.created_on = {label: 'Date', mobile: true}
        return columns
      }
    },
    mixins: [GenericList, Sort, Filter, DefaultValues, ColumnConf, DenunciationStatus, TableHeaderSticky],
    components: {DenunciationItem},
    methods: {
      companyName (value) {
        return value.name
      },
      updateLotFilter (e) {
        if (!isNil(e)) this.$set(this.filters, 'lot', e)
        else this.$set(this.filters, 'lot', undefined)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updateProgramFilter (e) {
        if (!isNil(e)) this.$set(this.filters, 'program', e)
        else this.$set(this.filters, 'program', undefined)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updatePromoteurFilter (e) {
        if (!isNil(e)) this.$set(this.filters, 'promoteur', e)
        else this.$set(this.filters, 'promoteur', undefined)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updateCompanyFilter (e) {
        this.$set(this.filters, 'company', e)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updateContactFilter (e) {
        if (!isNil(e)) this.$set(this.filters, 'buyer', e)
        else this.$set(this.filters, 'buyer', undefined)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updateSellerFilter (e) {
        this.$set(this.filters, 'seller', e)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      beforeGet () {
        if (isPlainObject(this.query.lot)) {
          this.query.lot = this.query.lot.pk
        }
        if (isPlainObject(this.query.seller)) {
          this.query.seller = this.query.seller.pk
        }
        if (isPlainObject(this.query.program)) {
          this.query.program = this.query.program.pk
        }
        if (isPlainObject(this.query.promoteur)) {
          this.query.promoteur = this.query.promoteur.pk
        }
        if (isPlainObject(this.query.buyer)) {
          this.query.buyer = this.query.buyer.pk
        }
        if (isPlainObject(this.query.company)) {
          this.query.company = this.query.company.pk
        }
      },
      getCompanies: debounce(function (query) {
        this.$api.companyService.get({name: query}).then(r => {
          this.companies = r.data.items
        })
      }, 300),
      getLots: debounce(function (query, program) {
        let params = {}
        if (query) params.ref = query
        if (program && program.pk) params.program = program.pk
        this.$api.lotService.get(params).then(r => {
          this.lots = r.data.items
        })
      }, 300),
      getPrograms: debounce(function (query) {
        this.$api.programService.get({name: query}).then(r => {
          this.programs = r.data.items
        })
      }, 300),
      getPromoteurs: debounce(function (query) {
        this.$api.promoteurService.get({name: query}).then(r => {
          this.promoteurs = r.data.items
        })
      }, 300),
      getContacts: debounce(function (query) {
        this.$api.contactService.get({last_name: query, sort: 'last_name:asc'}).then(r => {
          this.contacts = r.data.items
        })
      }, 300),
      getUsers (query) {
        let filters = {}
        if (query) {
          filters.first_name = query
        }
        this.$api.userService.get(filters).then(r => {
          this.users = r.data.items
        })
      },
      sellerName ({first_name, last_name}) {
        const names = {firstName: first_name, lastName: last_name}
        return `${names.lastName} ${names.firstName}`
      },
      updateDenunciation (id, denunciation) {
        const i = this.items.findIndex((o) => {
          return id === o.pk
        })
        if (i >= 0) {
          this.items.splice(i, 1, denunciation)
        }
        let text
        let type
        if (denunciation.status === 'refused') {
          text = 'Dénonciation refusée'
          type = 'is-success'
        } else {
          text = 'Dénonciation acceptée'
          type = 'is-success'
        }
        this.$notify({
          type,
          text
        })
      },
      successDelete (id, denunciation) {
        this.updateDenunciation(id, denunciation)
      },
      confirmDelete () {
        return this.$swal({
          title: 'Annulation',
          text: 'Êtes vous sûr de vouloir refuser cette dénonciation ?'
        })
      },
      getPendingAdvCount () {
        this.service.get({status: 'pending'}).then(r => {
          this.pendingDenunciation = r.data.total
        })
      },
      tagColors (v) {
        const COLORS = {
          pending: 'is-info',
          approved: 'is-success',
          refused: 'is-danger'
        }
        return COLORS[v]
      },
      updateDenuncePeriodFilter: debounce(function (e) {
        if (e.length === 2 && (e[0] !== this.filters.created_on__gte || e[1] !== this.filters.created_on__lte)) {
          this.$set(this.filters, 'created_on__gte', moment(e[0]).format('DD/MM/YYYY'))
          this.$set(this.filters, 'created_on__lte', moment(e[1]).format('DD/MM/YYYY'))
          this.$nextTick(() => {
            this.changeFilters()
          })
        } else if (e.length === 0) {
          this.$set(this.filters, 'created_on__gte', undefined)
          this.$set(this.filters, 'created_on__lte', undefined)
          this.$nextTick(() => {
            this.changeFilters()
          })
        }
      }, 500),
      beforeResetFilters () {
        this.denuncePeriod = null
      }
    },
    created () {
      if (this.$route.query.pk) {
        this.filters['pk'] = [this.$route.query.pk]
      }
      if (!this.$route.query.status && this.$route.query.pk) {
        this.filters['status'] = []
      } else if (!this.$route.query.status) {
        this.filters['status'] = ['pending']
      } else if (this.$route.query.status && !Array.isArray(this.$route.query.status)) {
        this.filters['status'] = [this.$route.query.status]
      } else if (this.$route.query.status) {
        this.filters['status'] = this.$route.query.status
      }
      this.getPendingAdvCount()
      this.getPrograms()
      this.getCompanies()
      this.getLots()
      this.getUsers()
      this.getContacts()
      if (this.isDistributeurMode) {
        this.promoteurs = this.promoteursList.slice()
      }
      this.changeFilters()
    }
  }
</script>

<style>
  is-annonce {
    background-color: #f87051
  }
</style>



// WEBPACK FOOTER //
// src/components/denunciation/DenunciationList.vue